import React, { useState, useEffect } from "react";
import { MagnifyingGlassIcon, LinkIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useSearch } from "../util/SearchContext";

export default function SearchBarLong({ isSearching }) {
  const { searchQuery, setSearchQuery, handleSearch } = useSearch();

  const placeholders = [
    "Search: vegetarian soup with lentils",
    "Search: low-carb stir fry",
    "Search: chicken tacos",
    "Search: Mexican dinner recipes",
    "Submit a recipe: https://cookieandkate.com/pinto-posole-recipe/",
    "Submit a recipe: https://www.feastingathome.com/kimchi-fried-rice/",
    "Submit a recipe: https://www.halfbakedharvest.com/chipotle-sweet-potato-tacos/",
  ];

  const [placeholderIndex, setPlaceholderIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
    }, 3000); // Rotate every 3 seconds
    return () => clearInterval(interval);
  }, [placeholders.length]);

  const handleInput = (e) => setSearchQuery(e.target.value);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch(searchQuery);
    }
  };

  // When clear ("x") is clicked, clear the search query and re-run search with an empty query.
  const clearSearch = () => {
    setSearchQuery("");
    handleSearch("");
  };

  return (
    <div className="w-full">
      <div className="flex items-center bg-white border border-gray-300 rounded-full shadow-sm px-2 py-[.25rem]">
        {/* Search button on the left */}
        <button
          onClick={() => handleSearch(searchQuery)}
          className="bg-white text-gray-500 p-2 rounded-full transition duration-300 hover:text-green-600"
        >
          {searchQuery.startsWith("http") ? (
            <LinkIcon className="w-5 h-5 sm:w-6 sm:h-6" />
          ) : (
            <MagnifyingGlassIcon className="w-5 h-5 sm:w-6 sm:h-6" />
          )}
        </button>

        {/* Input field */}
        <input
          type="text"
          value={searchQuery}
          onChange={handleInput}
          onKeyDown={handleKeyDown}
          placeholder={searchQuery ? "" : placeholders[placeholderIndex]}
          className="flex-1 min-w-0 bg-transparent outline-none pr-3 pl-1 text-gray-800 placeholder-gray-500 text-sm sm:text-base"
        />

        {/* Clear button (only shown when there's text) */}
        {searchQuery && (
          <button
            onClick={clearSearch}
            className="bg-gray-400 p-1 rounded-full hover:bg-gray-500 flex-shrink-0"
          >
            <XMarkIcon className="w-3 h-3 text-white" />
          </button>
        )}
      </div>
    </div>
  );
}
